// Name rules shared by every Layout Builder surface, matching the rest of the portal. Pure and free of
// React so the public planner bundle can import them.
//
// Integration and flow names: not blank and at least one \w character (an ASCII letter, digit or
// underscore), as the backend requires (tradingPartners/create.js, flowConfigurations/makeCreateObject.js).
// So a name made only of non-Latin letters is invalid.
export const NAME_RULE_MESSAGE = 'Use at least one letter or number.'

export const hasWordCharacter = name => typeof name === 'string' && /\w/.test(name)

// Flow names are also capped, as in the v2 flow editor (MAX_FLOW_NAME_LENGTH_ALLOWED in v2/Edit.jsx,
// which is too heavy to import here, so keep the two in step).
export const MAX_FLOW_NAME_LENGTH = 79
export const FLOW_NAME_TOO_LONG_MESSAGE = `Flow name must not be longer than ${MAX_FLOW_NAME_LENGTH} characters`

export const isFlowNameTooLong = name => typeof name === 'string' && name.trim().length > MAX_FLOW_NAME_LENGTH

export const isValidFlowName = name => hasWordCharacter(name) && !isFlowNameTooLong(name)

// A layout name only has to be non-blank, but it is never saved blank.
export const BLANK_LAYOUT_NAME_MESSAGE = 'Give the layout a name.'
